package com.vizio.redwolf.auth.utils

import com.vizio.redwolf.utils.ResponseHeaders
import com.vizio.redwolf.utils.model.PayFailureResponse
import kotlin.js.JsExport

@JsExport
sealed class JwtValidationResult {
    class SuccessValid : JwtValidationResult()
    data class SuccessJwtUpdated(val newJwt: String, val reason: TokenRefreshReason) : JwtValidationResult()
    data class SuccessAllTokensUpdated(val newJwt: String, val newAccessToken: String,  val newAccessTokenExpiry: String, val newRefreshToken: String, val reason: TokenRefreshReason) : JwtValidationResult()
    data class NeedsReLogin(val headers: ResponseHeaders, val failureResponse: PayFailureResponse) : JwtValidationResult()
    data class Failed(val headers: ResponseHeaders, val failureResponse: PayFailureResponse) : JwtValidationResult()
    data class Error(val headers: ResponseHeaders, val exception: Throwable) : JwtValidationResult()
    data class Timeout(val headers: ResponseHeaders, val exception: Throwable) : JwtValidationResult()

    fun <R> fold(
        onSuccessValid: (successValid: SuccessValid) -> R,
        onSuccessJwtUpdated: (successJwtUpdate: SuccessJwtUpdated) -> R,
        onSuccessAllTokensUpdated: (successUpdateAll: SuccessAllTokensUpdated) -> R,
        onNeedsReLogin: (needsReLogin: NeedsReLogin) -> R,
        onFailed: (failed: Failed) -> R,
        onError: (error: Error) -> R,
        onTimeout: (timeout: Timeout) -> R
    ): R {
        return when (this) {
            is SuccessValid -> onSuccessValid(SuccessValid())
            is SuccessJwtUpdated -> onSuccessJwtUpdated(SuccessJwtUpdated(this.newJwt, this.reason))
            is SuccessAllTokensUpdated -> onSuccessAllTokensUpdated(SuccessAllTokensUpdated(this.newJwt, this.newAccessToken, this.newAccessTokenExpiry, this.newRefreshToken, this.reason))
            is NeedsReLogin -> onNeedsReLogin(NeedsReLogin(this.headers, this.failureResponse))
            is Failed -> onFailed(Failed(this.headers, this.failureResponse))
            is Error -> onError(Error(this.headers, this.exception))
            is Timeout -> onTimeout(Timeout(this.headers, this.exception))
        }
    }
}
